export default {
    'event_list': 'Event List',
    'upcoming_event_list': 'Upcoming Event List',
    'display_upcoming_event': 'Show upcoming event',
    'no_events': "No any events...",
    'activities': 'Activities',
    'media-report': 'Media Report'
    // Add more translations as needed
};
